import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { SERVICE_SLUGS, SERVICE_IMAGES } from "../config";
import { Reveal, Page } from "../components/Reveal";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";

const Servicos = () => {
  const { t } = useLang();

  return (
    <Page>
      <SEO title={t.meta.servicos.title} desc={t.meta.servicos.desc} />
      <PageHero eyebrow={t.servicesPage.eyebrow} title={t.servicesPage.title} desc={t.servicesPage.sub} testid="services-hero" />

      <section className="bg-cream pb-24 sm:pb-32" data-testid="services-grid">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICE_SLUGS.map((slug, i) => (
              <Reveal key={slug} delay={(i % 3) * 0.1}>
                <Link
                  to={`/servicos/${slug}`}
                  data-testid={`service-card-${slug}`}
                  className="card-lift group flex h-full flex-col overflow-hidden rounded-3xl bg-white ring-1 ring-blush"
                >
                  <div className="img-zoom relative h-64 overflow-hidden bg-blush/30 sm:h-72">
                    <img src={SERVICE_IMAGES[slug]} alt={t.services[slug].name} className="h-full w-full object-contain" loading="lazy" />
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <h2 className="font-serif text-2xl font-semibold text-ink transition-colors group-hover:text-rosedeep">
                      {t.services[slug].name}
                    </h2>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/55">{t.services[slug].short}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-gold">
                      {t.common.learnMore}
                      <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}

            <Reveal delay={0.2}>
              <Link
                to="/avaliacao"
                data-testid="service-card-avaliacao"
                className="card-lift group flex h-full flex-col justify-between overflow-hidden rounded-3xl bg-rosedeep p-8 text-white"
              >
                <div>
                  <Sparkles className="w-8 h-8 text-gold" strokeWidth={1.5} />
                  <h2 className="mt-5 font-serif text-2xl font-semibold">{t.services.avaliacao.name}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-white/80">{t.services.avaliacao.short}</p>
                  <p className="mt-3 text-sm leading-relaxed text-white/70">{t.services.avaliacao.desc}</p>
                </div>
                <span className="mt-6 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-gold">
                  {t.common.learnMore}
                  <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          </div>

          <Reveal className="mt-12">
            <p className="rounded-2xl border border-gold/30 bg-white/70 px-6 py-4 text-center text-sm text-ink/60" data-testid="no-prices-note">
              {t.common.includedNote}
            </p>
          </Reveal>
        </div>
      </section>
    </Page>
  );
};

export default Servicos;
